import React from "react";

import { faRedoAlt } from "@fortawesome/pro-solid-svg-icons/faRedoAlt";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons/faTrashAlt";
import { faUndoAlt } from "@fortawesome/pro-solid-svg-icons/faUndoAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./EditBounds.module.scss";

interface Props {
  canChangeState: boolean;
  canRedo: boolean;
  canUndo: boolean;
  onRedo?: () => void;
  onStartOver?: () => void;
  onUndo?: () => void;
}

const EditButtons: React.FC<Props> = ({
  canChangeState,
  canRedo,
  canUndo,
  onRedo,
  onStartOver,
  onUndo,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      {canChangeState && (
        <>
          <Tooltip
            title={intl.formatMessage({
              id: "map.territory.topPanel.banner.actions.undo.tooltip",
              defaultMessage: "Undo",
              description: "Undo button tooltip in Create/Edit Territory banner in Territory Mode",
            })}
          >
            <Button
              disabled={!canUndo}
              icon={<FontAwesomeIcon icon={faUndoAlt} />}
              iconOnly
              onClick={onUndo}
              size="small"
              type="default"
            />
          </Tooltip>
          <Tooltip
            title={intl.formatMessage({
              id: "map.territory.topPanel.banner.actions.redo.tooltip",
              defaultMessage: "Redo",
              description: "Redo button tooltip in Create/Edit Territory banner in Territory Mode",
            })}
          >
            <Button
              disabled={!canRedo}
              icon={<FontAwesomeIcon icon={faRedoAlt} />}
              iconOnly
              onClick={onRedo}
              size="small"
              type="default"
            />
          </Tooltip>
        </>
      )}
      <Tooltip
        title={intl.formatMessage({
          id: "map.territory.topPanel.banner.actions.remove.tooltip",
          defaultMessage: "Start over",
          description: "Remove button tooltip in Create/Edit Territory banner in Territory Mode",
        })}
      >
        <Button
          icon={<FontAwesomeIcon icon={faTrashAlt} />}
          iconOnly
          onClick={onStartOver}
          size="small"
          type="default"
        />
      </Tooltip>
    </div>
  );
};

export default EditButtons;
